<fin-loyalty-view [pageTitle]="pageTitle$ | async">
  <ng-container>
    <div class="mr-xlarge-b">
      <fin-loyalty-upcoming-trips />
    </div>
    <div class="mr-xlarge-y">
      <fin-loyalty-add-trips />
    </div>

    <div class="mr-xlarge-b">
      <fin-sustainability-review-card *ngIf="enableShowingSAF" [headerClass]="'custom-decorated-heading pr-large-t'" />
      <fin-promotion-banners />
    </div>
  </ng-container>
</fin-loyalty-view>
